<h1 mat-dialog-title>Add Section</h1>
<div mat-dialog-content>
    <mat-form-field class="example-full-width">
      <input type="text" matInput placeholder="Name" 
      [(ngModel)]="Name"
      >
    </mat-form-field>
</div>
<div mat-dialog-actions class="dialogControllBtn">
  <button mat-raised-button (click)="onNoClick()">Cancel</button>
  <button mat-raised-button (click)="onSubmitClick()" 
  cdkFocusInitial [disabled]="Name == ''">Submit</button>
</div>